// extracted by extract-css-chunks-webpack-plugin
module.exports = {"infoBox":"qUHk3C","close":"r_-MHr"};